import { render, staticRenderFns } from "./c_hotspot.vue?vue&type=template&id=d4e4ffa6&scoped=true"
import script from "./c_hotspot.vue?vue&type=script&lang=js"
export * from "./c_hotspot.vue?vue&type=script&lang=js"
import style0 from "./c_hotspot.vue?vue&type=style&index=0&id=d4e4ffa6&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4e4ffa6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/qingchi/workspace/mimi/mer_mer_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d4e4ffa6')) {
      api.createRecord('d4e4ffa6', component.options)
    } else {
      api.reload('d4e4ffa6', component.options)
    }
    module.hot.accept("./c_hotspot.vue?vue&type=template&id=d4e4ffa6&scoped=true", function () {
      api.rerender('d4e4ffa6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfig/c_hotspot.vue"
export default component.exports